import { render, staticRenderFns } from "./checkbox-right-menu.vue?vue&type=template&id=4d72a1a6&scoped=true"
import script from "./checkbox-right-menu.vue?vue&type=script&lang=js"
export * from "./checkbox-right-menu.vue?vue&type=script&lang=js"
import style0 from "./checkbox-right-menu.vue?vue&type=style&index=0&id=4d72a1a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d72a1a6",
  null
  
)

export default component.exports